"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customCheckboxCell = ({ dataIndex, field, style }) => {
    return ((0, jsx_runtime_1.jsx)("td", { colSpan: 1, style: style, role: 'gridcell', "aria-selected": 'false', "aria-colindex": dataIndex, "data-grid-col-index": dataIndex, id: `m_grid_cell_${field}_${dataIndex}` }));
};
exports.default = customCheckboxCell;
